import { getTsgToken, getFrameworkServiceUrl } from '@sparky/framework'
import axios from 'axios'
import type { AxiosRequestConfig } from 'axios'
import { getVarValue } from '../../common/utils/Sparky'
// import mockHashesResponse from '../mockAPIResponse/mockHashes.json'


import { FF_USE_LOCAL_SUBSCRIPTION_SERVICE } from '../../common/utils/FeatureFlags'
import {
  SUPPORT_ACCOUNTS
} from '../../common/utils/ServiceUrls'
import { TSG_NONE } from '../constants'

export type AxiosRequestConfigWithTsg = AxiosRequestConfig & {
  tsg_id?: string | undefined
}
const includeClaims = getVarValue(FF_USE_LOCAL_SUBSCRIPTION_SERVICE) || false

const SUB_SVC_URL_KEY = 'subscription_service'
const SubscriptionAPI = axios.create({
  baseURL: getFrameworkServiceUrl(SUB_SVC_URL_KEY) || getVarValue(SUB_SVC_URL_KEY) || undefined,
  timeout: 300 * 1000
})

SubscriptionAPI.interceptors.request.use(async (config: AxiosRequestConfigWithTsg) => {
  const token = await getTsgToken(config?.tsg_id)
  config.headers = { ...config.headers, 'Authorization': `Bearer ${token}` }
  if (includeClaims) {
    config.headers.claims = token.split('.')[1]
  }
  return config
}, error => {
  return Promise.reject(error)
})

SubscriptionAPI.interceptors.response.use((response) => {
  return response
}, (error) => {
  throw new Error(error.response?.data?.message || error.response?.data?.error_message || error.response?.data?.msg || error.message)
})

const SubscriptionService = {
  supportAccounts: {
    get: async ({ tsg_id, email }: { tsg_id?: string; email: string }) => {
      const axiosObject: AxiosRequestConfigWithTsg = {
        params: {
          email
        },
        tsg_id: TSG_NONE.id
      }
      return SubscriptionAPI.get(SUPPORT_ACCOUNTS, axiosObject)
    }
  }
}

export default SubscriptionService
